export const INSURABILITY_DOCUMENT_KEY = 'doc_asegurabilidad';

export const INSURABILITY_CARD_TITLE = 'Declaración de asegurabilidad';

export const INSURABILITY_MODAL_TITLE = 'Recuerda';
